import { TextConfigurationContent } from '@/types';

export const isComplexTextContent = (
  content: string | TextConfigurationContent
): content is TextConfigurationContent => typeof content !== 'string';
